import { useNavigate } from 'react-router-dom';
import h, { shouldShowParentalRatingPopup } from '../helpers/common';
import { useSelector } from 'react-redux';
import moment from 'moment';
import channelsUtil from '../helpers/channelsUtil';
import { useDispatch } from 'react-redux';
import { showUpgradedModal } from '../store/reducers/generalConfigurationSlice';
import { checkShowLockIcon } from '../helpers/vod';
import { ParentalLock } from '../components/elements/ParentalLock';
import viewEvents from '../helpers/viewEvents';
import React from 'react';
import url from '../helpers/url';
import { useConfigurationSections } from './useConfiguration';

export default function useCatchupActions() {
    const navigate = useNavigate();
    const userChannels = useSelector((state: any) => state.liveTv?.userChannels);
    const lang = h.getLang();
    const dispatch = useDispatch();
    // Using React Query instead of Redux for configuration
    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable;
    const playbackTimestamp = url.getQuery('playbackTimestamp') ?? null;

    const navigateToPlayer = (catchupData) => {
        if (catchupData?.ratings && shouldShowParentalRatingPopup(catchupData?.ratings)) {
            viewEvents.broadcast('openPopup', {
                component: React.createElement(ParentalLock),
                screen: 'catchupPlayer',
            });
            return;
        }
        const channel = channelsUtil.getChannelByStationId(catchupData.stationId, userChannels);
        const guids = channel?.subscriptions.map((el) => el?.subscriptionGUID) || [];
        const isLocked = guids?.length > 0 && checkShowLockIcon(guids) && enableLockIcon;
        if (isLocked) {
            dispatch(showUpgradedModal(true));
            return;
        } else {
            navigate(`${lang === 'en' ? `/${lang}` : ''}/catchup-player`, {
                state: {
                    programData: {
                        ...catchupData,
                        playbackTimestamp: playbackTimestamp,
                        title: catchupData.title,
                        name: catchupData.title,
                        startTime: moment(catchupData.startTime).valueOf(), //1732434900000, //catchupData.startTime,
                        endTime: moment(catchupData.endTime).valueOf(), // 1732441800000,// catchupData.endTime,
                        tuningURLs: {
                            catchUpURL: catchupData.tuningURLs.catchUpURL, //'https://link.theplatform.eu/s/HLFsfC/JPD5qaDb3TMn', //catchupData.tuningURLs.catchUpURL,
                        },
                        poster: catchupData?.coverImage,
                        callSign: catchupData.stationCallSign,
                        listingId: catchupData.listingId,
                        guid: catchupData?.guid,
                        paId: catchupData?.paId,
                        channelName: channel?.channelTitle,
                        channelTitle: channel?.channelTitle,
                        channelNumber: channel?.channelNumber,
                        ...(channel?.category &&
                            Array.isArray(channel.category) &&
                            channel.category[0] && {
                                channelCategory: channel.category[0],
                            }),
                    },
                },
            });
        }
    };

    return { navigateToPlayer };
}
